<template>
  <div class="articleFilter-head_container">
    <div class="articleFilter_search">
      <input type="search" id="search" :placeholder="placeholderText" v-model="searchText" @keyup.enter="searchData()"/>
      <label for="search"></label>
      <button type="submit" id="submit" @click="searchData()" aria-label="search icon">
        <svg viewBox="0 0 32 32" id="search" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M20.241 22.02a10.024 10.024 0 0 1-6.173 2.115C8.508 24.135 4 19.628 4 14.068 4 8.508 8.507 4 14.068 4c5.56 0 10.067 4.507 10.067 10.068 0 2.326-.789 4.468-2.114 6.173L28 26.221 26.22 28l-5.979-5.98Zm1.377-7.952a7.55 7.55 0 1 1-15.101 0 7.55 7.55 0 0 1 15.101 0Z" />
        </svg>
      </button>
      <button v-show="showClearButton" type="submit" id="submit" @click="clearAll()" aria-label="close icon">
        <svg aria-hidden="true" class="icon"><title>close</title> <use xlink:href="#close" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
      </button>
    </div>
    <div class="articleFilter_filter">
      <button class="filter-cta" :class="{ expanded: expandfilter }" @click="openFilter()" aria-label="filter icon">
        <svg v-if="!expandfilter" class="i_icon icon_filters" width="18" height="20" viewBox="0 0 18 20">
          <rect y="2" width="18" height="2" rx="1"></rect>
          <rect y="9" width="18" height="2" rx="1"></rect>
          <rect y="16" width="18" height="2" rx="1"></rect>
          <circle cx="3" cy="3" r="3"></circle>
          <circle cx="13" cy="10" r="3"></circle>
          <circle cx="7" cy="17" r="3"></circle>
        </svg> 
        <svg v-else class="i_icon icon_close" width="18" height="18" viewBox="0 0 18 18">
          <path d="M16.0711 1.92896L1.92894 16.0711" stroke-width="3"></path>
          <path d="M16.0711 16.071L1.92894 1.92891" stroke-width="3"></path>
        </svg>
        <span class="filter-cta__text">{{ filterText }} <span v-if="totalSelected !== 0">{{ ' (' + totalSelected + ')' }}</span></span>
      </button>
    </div>
    <p v-if="!isMobile" class="articleFilter_numberOfFound">
      {{ totalResult }} {{ totalRecord }}
    </p>
    <div class="articleFilter_selectedFilter">
      <transition @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave"
        @after-leave="afterLeave">
        <div class="articleFilter_current" v-show="visibleSelectedTags">
          <button @click="isclosed(item)" class="selected-cta" v-for="(item, idx) in selectedItem" :key="getChipKey(item, idx)">
            {{ getChipLabel(item) }}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"
                d="M368 368 144 144m224 0L144 368" />
            </svg>
          </button>
          <button v-if="totalSelected > 0" @click="clearFix()" class="clearAll">
            {{ clearText }}
          </button>
        </div>
      </transition>
      <transition @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave"
        @after-leave="afterLeave">
        <div class="articleFilter_all" v-show="openFilterlist" ref="panel">
          <article-filter-list
            ref="filterList"
            :initialdata="initialdata"
            :open-filter="expandfilter"
            :selected-items="selectedItem"
            @update-selected-count="handleSelectedCount"
            @facet-change="handleFacetChange"
          />
        </div>
      </transition>
    </div>
    <p v-if="isMobile" class="articleFilter_numberOfFound">
      {{ totalResult }} {{ totalRecord }}
    </p>
    <article-listing v-if="selectedArticles.length > 0" :cards="selectedArticles"></article-listing>
    <button v-if="isShowMore" @click="nextPage()" class="loadmore">
      {{ loadMoreText }}
    </button>
    <p v-if="noResult" class="no_result">
      {{ noResultText }}
    </p>
  </div>
</template>
<script>
import articleFilterList from './article-filter-list.vue';
import articleListing from '../article-listing/article-listing.vue';
export default {
  name: 'articleFilter',
  components: {
    articleFilterList,
    articleListing
  },
  props: {
    filterText: {
      type: String,
      default: 'Filters',
    },
    initialdata: {
      type: [Object, Array],
      required: true,
    },
    clearText: {
      type: String,
      default: 'Clear All',
    },
    endPoint: {
      type: String,
      default: 'article/webzine/articlefilter',
    },
    loadMoreText: {
      type: String,
      default: 'loadmore',
    },
    pageId: {
      type: String,
      default: '',
    },
    noResultText: {
      type: String,
      default: '',
    },
    totalRecord: {
      type: String,
      default: 'articles found',
    },
    isCategory: {
      type: Boolean,
      default: true,
    },
    categoryVal: {
      type: String,
      default: 'hair care',
    },
    placeholderText: {
      type: String,
      default: 'Search for an article...',
    }
  },
  data() {
    return {
      openFilterlist: false,
      visibleSelectedTags: true,
      expandfilter: false,
      totalSelected: 0,
      selectedItem: [],
      hideClearFix: false,
      itemRemove: '',
      currentPage: 1,
      keyword: 'hair color',
      latestFilter: {},
      searchText: '',
      inputFocused: false,
      lastFacetChange: null,
      selectedArticles: [],
      isInitialSelectionSync: true,
      totalResult: 0,
      showClearButton: false,      
      isShowMore: false,
      noResult: false,
      isMobile: window.innerWidth < 768
    };
  },

  methods: {
    handleFacetChange(payload) {
      this.lastFacetChange = payload;
      this.$emit('facet-change', payload);
    },
    handleSelectedCount(list, data) {
      const items = Array.isArray(list) ? list : [];
      this.totalSelected = items.length;
      this.selectedItem = items.map((f) => ({
        query: f.query,
        name: f.name,
        title: f.title || this.getFilterTitleByQuery(f.query),
      }));
      this.latestFilter = data || {};
      this.currentPage = 1;
      this.getData(false);
    },
    getFilterTitleByQuery(query) {
      const filter = (this.initialdata || []).find((f) => f.query === query);
      return filter ? filter.title : '';
    },
    getChipLabel(item) {
      if (!item || typeof item === 'string') return item;
      const name = item.name || item;
      const sameNameCount = this.selectedItem.filter((f) => (f.name || f) === name).length;
      if (sameNameCount > 1 && item.title) return `${name} (${item.title})`;
      return name;
    },
    getChipKey(item, idx) {
      if (!item || typeof item === 'string') return `chip-${idx}`;
      return `${item.query}_${item.name}_${idx}`;
    },
    nextPage() {
      this.currentPage++;
      this.getData(true);
    },
    searchData() {
      this.currentPage = 1;
      this.getData(false);
      this.showClearButton = true;
    },
    clearAll() {
      this.searchText = '';
      this.currentPage = 1;
      this.getData(false);
      this.showClearButton = false;
    },
    getRequestUrl() {
      const queryParams = new URLSearchParams();
      queryParams.set('pageId', this.pageId);
      queryParams.set('currentpage', this.currentPage);
      queryParams.set('searchKeyword', this.searchText);
      const cat = this.isCategory ? this.latestFilter.category : this.categoryVal;
      const con = this.latestFilter.concern;
      const kw = this.latestFilter.keywords;
      queryParams.set('filterCategory', Array.isArray(cat) ? cat.join(',') : (cat || ''));
      queryParams.set('filterConcern', Array.isArray(con) ? con.join(',') : (con || ''));
      queryParams.set('filterKeywords', Array.isArray(kw) ? kw.join(',') : (kw || ''));
      return `${window.location.origin}/${this.endPoint}?${queryParams.toString()}`;
    },
    getData(flag) {
      let api = `${this.getRequestUrl()}`;
      fetch(api)
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
          }
          if (data.blogs && data.blogs.length > 0) {
            if (flag) {
              this.selectedArticles.push(...data.blogs);
            } else {
              this.selectedArticles = data.blogs;
            }            
            if (data.total_result_count / 12 > this.currentPage) {
              this.isShowMore = true;
            } else {
              this.isShowMore = false;
            }
            this.noResult = false;
            this.totalResult = data.total_result_count;
          } else {
            this.selectedArticles = [];
            this.noResult = true;
            this.isShowMore = false;
            this.currentPage = 1;
            this.totalResult = 0;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    openFilter() {
      this.openFilterlist = !this.openFilterlist;
      this.visibleSelectedTags = !this.visibleSelectedTags;
      this.expandfilter = !this.expandfilter;
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },
    // Transition hooks
    beforeEnter(el) {
      el.style.height = '0';
    },
    enter(el) {
      el.style.transition = 'height 0.5s ease';
      // Force repaint to ensure transition is applied
      void el.offsetHeight;
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter(el) {
      el.style.height = 'auto';
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
      // Force repaint
      void el.offsetHeight;
      el.style.transition = 'height 0.5s ease';
      el.style.height = '0';
    },
    afterLeave(el) {
      el.style.height = '';
    },
    clearFix() {
      this.unselectAllFacetsInData();
      this.selectedItem = [];
      this.hideClearFix = false;
      this.totalSelected = 0;
      this.currentPage = 1;
      this.latestFilter = {};
    },
    unselectAllFacetsInData() {
      if (!Array.isArray(this.initialdata)) return;
      this.initialdata.forEach((filter) => {
        (filter.facetlist || []).forEach((f) => { f.selected = false; });
      });
      if (this.$refs.filterList) this.$refs.filterList.syncCheckedLabelsFromData();
    },
    isclosed(item) {
      if (!Array.isArray(this.initialdata)) return;
      const query = item && item.query;
      const name = item && (item.name != null ? item.name : item);
      if (query == null || name == null) return;
      const filter = this.initialdata.find((f) => f.query === query);
      if (!filter || !filter.facetlist) return;
      const facet = filter.facetlist.find((f) => f.name === name);
      if (facet) facet.selected = false;
      if (this.$refs.filterList) this.$refs.filterList.syncCheckedLabelsFromData();
      // Child watch will emit update-selected-count → handleSelectedCount → getData()
    },
    buildLatestFilterFromData() {
      this.latestFilter = {};
      if (!Array.isArray(this.initialdata)) return;
      this.initialdata.forEach((filter) => {
        const selectedValues = (filter.facetlist || [])
          .filter((f) => f.selected)
          .map((f) => f.name);
        if (selectedValues.length) {
          this.latestFilter[filter.query] = selectedValues;
        }
      });
    },
  },
};
</script>
